import React from 'react';
import { Header } from '../components/landing/Header';
import { Hero } from '../components/landing/Hero';
import { PainValidation } from '../components/landing/PainValidation';
import { AuthoritySection } from '../components/landing/AuthoritySection';
import { VisualProofSection } from '../components/landing/VisualProofSection';
import { SolutionSection } from '../components/landing/SolutionSection';
import { HowItWorks } from '../components/landing/HowItWorks';
import { Testimonials } from '../components/landing/Testimonials';
import { IdentitySection } from '../components/landing/IdentitySection';
import { FAQ } from '../components/landing/FAQ';
import { FinalCTA } from '../components/landing/FinalCTA';
export function LandingPage() {
  return <div className="min-h-screen bg-primary selection:bg-accent selection:text-white" data-id="element-329">
      <Header data-id="element-330" />
      <main data-id="element-331">
        <Hero data-id="element-332" />
        <PainValidation data-id="element-333" />
        <AuthoritySection data-id="element-334" />
        <VisualProofSection data-id="element-335" />
        <SolutionSection data-id="element-336" />
        <HowItWorks data-id="element-337" />
        <Testimonials data-id="element-338" />
        <IdentitySection data-id="element-339" />
        <FAQ data-id="element-340" />
        <FinalCTA data-id="element-341" />
      </main>

      <footer className="bg-card py-12 border-t border-border" data-id="element-342">
        <div className="max-w-7xl mx-auto px-4" data-id="element-343">
          <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-344">
            <div data-id="element-345">
              <h3 className="text-white font-bold mb-4" data-id="element-346">PetiteStyle</h3>
              <p className="text-text-muted text-sm" data-id="element-347">
                Find clothes that actually fit. AI-powered virtual try-on for
                women under 5'4".
              </p>
            </div>
            <div data-id="element-348">
              <h4 className="text-white font-semibold mb-4" data-id="element-349">Product</h4>
              <ul className="space-y-2 text-sm text-text-muted" data-id="element-350">
                <li data-id="element-351">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-352">
                    How It Works
                  </a>
                </li>
                <li data-id="element-353">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-354">
                    Vendors
                  </a>
                </li>
                <li data-id="element-355">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-356">
                    Virtual Try-On
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-357">
              <h4 className="text-white font-semibold mb-4" data-id="element-358">Company</h4>
              <ul className="space-y-2 text-sm text-text-muted" data-id="element-359">
                <li data-id="element-360">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-361">
                    About
                  </a>
                </li>
                <li data-id="element-362">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-363">
                    Contact
                  </a>
                </li>
                <li data-id="element-364">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-365">
                    Privacy
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-366">
              <h4 className="text-white font-semibold mb-4" data-id="element-367">Connect</h4>
              <ul className="space-y-2 text-sm text-text-muted" data-id="element-368">
                <li data-id="element-369">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-370">
                    Instagram
                  </a>
                </li>
                <li data-id="element-371">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-372">
                    Twitter
                  </a>
                </li>
                <li data-id="element-373">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-374">
                    Facebook
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-border pt-8 text-center text-text-muted text-sm" data-id="element-375">
            <p data-id="element-376">
              &copy; {new Date().getFullYear()} PetiteStyle. All rights
              reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}